import React, { useRef } from 'react';
import { DefaultButton, PrimaryButton, TextField, Stack } from '@fluentui/react';
import { Field, Form, Formik } from 'formik';
import { parse } from 'csv-parse/browser/esm/sync';
import DocumentUpload from '../../components/DocumentUpload';
import Dropdown from '../../components/Dropdown';
import DriOperations from '../../actions/driOperations';
import styles from './styles';

const initialValues = {
  silo: '3p-tla',
  file: null,
};

const siloOptions = [
  { key: '3p-tla', text: '3p-tla' },
  { key: '1p-azure', text: '1p-azure' },
];

const stackTokens = {
  childrenGap: 10,
};

const onSend = async (silo, file) => {
  const fileReader = new FileReader();
  fileReader.addEventListener('load', e => {
    const input = e.target.result instanceof ArrayBuffer ? '' : e.target.result;
    const records = parse(input, {
      columns: true,
      skip_empty_lines: true,
    });
    DriOperations.sendEvents(silo, records)
      .then(res => {
        if (res.ok) {
          // eslint-disable-next-line no-alert
          alert('Messages sent to service bus');
        } else {
          res.json().then(({ message }) => {
            // eslint-disable-next-line no-alert
            alert(`Messages not sent: ${message}`);
          });
        }
      })
      // eslint-disable-next-line no-alert
      .catch(err => alert(`Error: ${err.message}`));
  });
  fileReader.readAsText(file);
};
const SendNewEventForm = () => {
  const uploadRef = useRef(null);
  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={({ silo, file }) => {
          onSend(silo, file);
        }}
      >
        {({ submitForm }) => {
          return (
            <Form className={styles.form}>
              <Stack tokens={stackTokens}>
                <Field name="silo" component={Dropdown} options={siloOptions} />
                <Field name="file">
                  {({ field: { value, name }, form: { setFieldValue } }) => {
                    const setFile = files => {
                      if (files.length !== 1) {
                        return;
                      }
                      setFieldValue(name, files[0]);
                    };
                    return (
                      <Stack tokens={stackTokens} horizontal smCols={1} mdCols={3} lgCols={3}>
                        <Stack.Item grow align="stretch">
                          <TextField underlined disabled value={value?.name} />
                        </Stack.Item>
                        <DefaultButton
                          text="Select csv"
                          onClick={() => uploadRef.current.click()}
                        />
                        <DocumentUpload
                          onUpload={setFile}
                          ref={uploadRef}
                          id="csv-upload"
                          accept=".csv"
                          className={styles.uploader}
                        />
                      </Stack>
                    );
                  }}
                </Field>
                <PrimaryButton text="Upload" onClick={submitForm} />
              </Stack>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default SendNewEventForm;
